import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from 'src/app/extensions/components/components.module';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import '@progress/kendo-angular-intl/locales/ro/all';
import { FormsModule } from '@angular/forms';
import { LogsRoutingModule } from './logs-routing.module';
import { LogListComponent } from './log-list/log-list.component';
import { LogListViewComponent } from './log-list/log-list-view/log-list-view.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LogListFilterComponent } from './log-list/log-list-filter.component/log-list-filter.component';
import { PipeModule } from 'src/app/extensions/pipes/pipe.module';
import { InputsModule } from '@progress/kendo-angular-inputs';

@NgModule({
  imports: [
    CommonModule,
    LogsRoutingModule,
    TranslateModule.forChild(),
    ComponentsModule,
    DateInputsModule,
    FormsModule,
    NgbModule,
    PipeModule,
    InputsModule,
  ],
  declarations: [LogListComponent, LogListViewComponent, LogListFilterComponent],
})
export class LogsModule {}
